import { render, staticRenderFns } from "./ModalPromotion.vue?vue&type=template&id=058cf210&scoped=true&"
import script from "./ModalPromotion.vue?vue&type=script&lang=js&"
export * from "./ModalPromotion.vue?vue&type=script&lang=js&"
import style0 from "./ModalPromotion.vue?vue&type=style&index=0&id=058cf210&prod&lang=scss&scoped=true&"
import style1 from "./ModalPromotion.vue?vue&type=style&index=1&id=058cf210&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058cf210",
  null
  
)

export default component.exports